import * as $ from 'jquery';
import lozad from 'lozad';
import { initTracker } from '../../../shared/js/tracker';
import { initShowcaseCore, initBackRedirect } from '../../../shared/js/showcase-core';
import { ready as apiReady } from '../../../shared/js/api-host';

if (process.env.NODE_ENV === 'development') {
  import('../../../shared/mocks/setup');
}

import '../scss/style.scss';
import './components/marquee';
import './components/popup-forms';
import './components/inputmask';
import './components/fancybox';

const observer = lozad();
observer.observe();

$(function () {
  Promise.resolve(apiReady).then(() => {
    initShowcaseCore({
      clickSelector: '.tpl-offer__wrapper',
      template,
      showPreloader,
      hidePreloader,
    });

    function applyPersonalizedTitle(fields) {
      if (!fields) return;
      const { name, fullamount } = fields;
      const hasPersonal = Boolean(name) && (typeof fullamount === 'number' && !Number.isNaN(fullamount));
      const $default = $('[data-default-title]');
      const $personal = $('[data-personalized-title]');
      if (!hasPersonal) {
        // Ensure default visible if backend didn't render personalized
        if ($default.length) $default.show();
        if ($personal.length) $personal.hide();
        return;
      }
      // Fill fields
      const formatAmount = (n) => (typeof n === 'number' ? n.toLocaleString('ru-RU').replace(/\s/g, '.') : String(n));
      $('[data-field-name]').text(String(name));
      $('[data-field-fullamount]').text(formatAmount(fullamount));
      // Toggle visibility
      if ($default.length) $default.hide();
      if ($personal.length) $personal.show();
    }

    // Apply immediately if data already present
    try {
      const fields = window.__visitData && window.__visitData.fields;
      if (fields) applyPersonalizedTitle(fields);
    } catch (_) {}

    // React to visit:tracked events
    window.addEventListener('visit:tracked', (e) => {
      const fields = e && e.detail && e.detail.fields;
      applyPersonalizedTitle(fields);
    });
  });

  $(document)
    .off('click', '[data-scroll-to]')
    .on('click', '[data-scroll-to]', function (event) {
      event.preventDefault();

      const id = String($(this).attr('data-scroll-to') || '').trim();
      if (!id) return;

      const el = document.getElementById(id);
      if (!el) return;

      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
});

$(document).ready(function () {
  if ($('.tpl-marquee__init').length) {
    $('.tpl-marquee__init').marquee({
      delayBeforeStart: 0,
      duplicated: true,
      startVisible: true,
    });
  }
});

initBackRedirect();

function showPreloader(currLink) {
  $(currLink).css('pointer-events', 'none');
  $(currLink).find('.offer-button span').addClass('hide');
  $(currLink).find('.lds-ellipsis').removeClass('hide');
}

function hidePreloader(currLink) {
  $(currLink).css('pointer-events', 'auto');
  $(currLink).find('.offer-button span').removeClass('hide');
  $(currLink).find('.lds-ellipsis').addClass('hide');
}

function template(offer, num = '1') {
  return `
    <div
      class="tpl-offer__wrapper tpl-col-gutters tpl-js-clicked-offer"
      data-offer-id="${offer.id}"
      ${offer.offerVisitId ? `data-offer-visit-id="${offer.offerVisitId}"` : ''}
    >
      <div class="tpl-offer tpl-sys-offer">
        ${num == '1' ? `<span class="tpl-offer__status">${offer.tag || getRandomTag()}</span>` : ''}
        <span class="tpl-offer__content">
          <span class="tpl-offer__information">
            <span class="tpl-offer__logo">
              <img src="${offer.image}" alt="" />
            </span>
          </span>
          <span class="tpl-offer__price--wrapper">
            <span class="tpl-offer__price">Доступно:<br />
              <span data-offer-unit="max.">${offer.amount?.toLocaleString('ru-RU') || 0} ₽</span>
            </span>
            <span class="tpl-offer__params">
              <span>до ${offer.termEnd || 0} дней</span>
              <span>Первый заём ${offer.firstLoan || 'бесплатно'}</span>
            </span>
          </span>
          <button class="tpl-btn tpl-btn-wide offer-button">
            <span>Получить деньги</span>
            <div class="lds-ellipsis hide">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </button>
        </span>
      </div>
    </div>
  `;
}

function getRandomTag() {
  const tags = ['Без справок', 'Первый займ - бесплатно', 'Без переплат'];
  return tags[Math.floor(Math.random() * tags.length)];
}

initTracker();
